<template>
  <div class="page">
    <navigation
      :theme="{
        background:'#421636',
        color:'#fff',
      }"
      arrTheme='white'
    >
      <span>周三添财日</span>
      <span
        slot="right"
        class="rule-txt"
        @click="jumpRule"
      >活动规则</span>
    </navigation>
    <div class="people-remain">
      <div class="number">{{detail.progress || 0}}%</div>
      <div class="remain-footer">库存进度</div>
    </div>
    <div class="detail-container">
      <img
        src="./images/img_biaoti@2x.png"
        class="header-img"
      >
      <div class="end-time">
        <span>距离免费领券时间仅剩</span>
        <van-count-down :time="countDownTime">
          <template #default="timeData">
            <span class="block">{{ timeData.hours }}</span>
            <span class="colon">小时</span>
            <span class="block">{{ timeData.minutes }}</span>
            <span class="colon">分</span>
          </template>
        </van-count-down>
      </div>
      <div class="card-container">
        <img
          src="./images/card_01@2x.png"
          class="main-btn"
          data-sensors-click
          @click="lockQuota"
          v-if="!detail.activeRecordStatus"
        >
        <img
          src="./images/card_02@2x.png"
          class="main-btn2"
          @click="$router.push('/middle/limit')"
          v-if="detail.activeRecordStatus === 'NOT_USE'"
          data-sensors-click
        >
        <img
          src="./images/card_03@2x.png"
          class="noAnimation"
          v-if="detail.activeRecordStatus === 'USED'"
        >
        <i
          class="light"
          v-for="item in 10"
          :key="item"
        ></i>
      </div>
      <div class="rules-container">
        <img src="./images/img_tixian@2x.png">
      </div>
      <!-- v-if="detail.rollingData && detail.rollingData.length" -->
      <withdraw-user-flipper
      
        :background="'linear-gradient( 90deg, #7948E2 0%, #7116D9 100%)'"
        :amountTextColor="'#FFD08B'"
        :users="detail.rollingData"
      />
      <img
        src="./images/img_dibu@2x.png"
        class="footer"
      >
    </div>

    <div
      class="dialog-card"
      v-if="showDialog"
      :class="{showDialog}"
    >
      <i class="mask"></i>
      <img
        src="./images/dialog-bg.png"
        class="bg"
      >
      <img
        src="./images/card_02@2x.png"
        class="main-info dialog-btn"
        @click="$router.push('/middle/limit')"
        data-sensors-click
      >
      <img
        src="./images/btn_close@2x.png"
        class="close"
        @click="showDialog= false"
        data-sensors-click
      >
    </div>
  </div>
</template>

<script>
import withdrawUserFlipper from './components/withdraw-user-flipper.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    withdrawUserFlipper
  },
  data () {
    return {
      showDialog: false,
      detail: {
        residue: 0,
        rollingData: []
      }
    }
  },
  mounted () {
    this.getDetail()
    this.$bus.$emit('ready')
  },
  computed: {
    countDownTime () {
      // 获取当前时间戳
      const now = new Date().getTime()
      return this.detail.residue - now
    }
  },
  methods: {
    ...mapActions('activities', ['getActivityDetail', 'receiveActive']),
    jumpRule () {
      this.$router.push({
        path: '/act-one-rules'
      })
    },
    async lockQuota () {
      if (window.pending) return
      window.pending = true
      const { success } = await this.receiveActive({
        activeCode: 'ACTIVE_BOX',
        subCode: 'ACTIVE_BOX_LOAN_QUEUE'
      })
      window.pending = false
      this.getDetail()
      if (success) {
        this.showDialog = true
      }
    },
    // 获取活动详情
    async getDetail () {
      const { success, data } = await this.getActivityDetail({
        activeCode: 'ACTIVE_BOX',
        subCode: 'ACTIVE_BOX_LOAN_QUEUE'
      })
      if (success) {
        this.detail = data
      }
    },
    // 提现
    withdraw () {
      this.$router.push('/middle/limit')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  background: linear-gradient(270deg, #421636 0%, #2a1b44 100%);
  min-height: 100vh;
  .people-remain {
    background: url("./images/act2_img_jindu@2x.png") no-repeat;
    background-size: 100% 100%;
    width: 110px;
    height: 110px;
    position: fixed;
    bottom: 510px;
    right: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
    line-height: 28px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    z-index: 10;
    .number {
      margin-top: 37px;
    }
    .remain-footer {
      margin-top: 12px;
    }
  }
  .rule-txt {
    font-family: PingFangSC, PingFang SC;
    font-size: 28px;
    color: #ffffff;
    line-height: 40px;
    text-align: right;
    font-style: normal;
    margin-right: 40px;
    display: block;
  }
  .detail-container {
    display: flex;
    flex-direction: column;
    .header-img {
      width: 559px;
      margin: 90px auto 40px;
    }
    .end-time {
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      color: #ffffff;
      line-height: 37px;
      display: flex;
      justify-content: center;
      .van-count-down {
        display: flex;
        align-items: center;
        .block {
          color: #ff4633;
          background-color: #ffd9d9;
          border-radius: 4px;
          font-size: 26px;
          width: 36px;
          height: 36px;
          line-height: 36px;
          margin-left: 9px;
          margin-right: 9px;
          text-align: center;
          display: block;
        }
        .colon {
          color: #fff;
          font-size: 26px;
        }
      }
    }
    .card-container {
      background: url("./images/img_guang@2x.png") no-repeat left bottom;
      background-size: 100% 160px;
      height: 870px;
      display: flex;
      justify-content: center;
      position: relative;
      overflow: hidden;
      & > img {
        width: 620px;
        height: 810px;
        cursor: pointer;
        z-index: 9;
      }
      & > img:not(.noAnimation) {
        animation: move 0.8s infinite alternate;
      }
      @keyframes move {
        from {
          transform: translateY(10px);
        }
        to {
          transform: translateY(-30px);
        }
      }
      .light {
        width: 4px;
        height: 300px;
        border-radius: 300px;
        overflow: hidden;
        pointer-events: none;
        background: linear-gradient(
          rgba(255, 255, 255, 1) 0%,
          rgba(255, 255, 255, 0.1) 50%,
          rgba(255, 255, 255, 0) 100%
        );
        filter: drop-shadow(0px -3px 22px rgba(255, 255, 255, 0.8));
        position: absolute;
        bottom: -300px;
        left: -30px;
        animation: light 3s ease-in infinite;
      }
      @lightlist:30, 50, 600, 700,100,130, 440, 510,123,223;
      @lightlistlength: length(@lightlist);
      .loop(@index) when(@index>0) {
        .light:nth-of-type(@{index}) {
          left: extract(@lightlist, @index) * 1px;
          animation-delay: 0.3s * @index;
        }
        .loop(@index - 1);
      }
      .loop(@lightlistlength);
      @keyframes light {
        from {
          transform: translateY(0);
        }
        to {
          transform: translateY(-1300px); opacity: .3;
        }
      }
    }
  }
  .rules-container {
    display: flex;
    justify-content: center;
    margin-top: 23px;
    img {
      width: 650px;
      height: 620px;
    }
  }
  .footer {
    width: 322px;
    margin: 66px auto;
  }
  .dialog-card {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 999999;

    @keyframes show {
      0% {transform: translate(-50%, -50%) scale(0.3) rotateY(-180deg)}
      100% {transform: translate(-50%, -50%) scale(1) rotateY(0)}
    }
    .mask {
      background: rgba(0, 0, 0, 0.9);
      position: absolute;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
    }
    &.showDialog {
      .main-info {animation: show 1s forwards;}
    }
    .main-info {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 620px;
      height: 810px;
    }
    .bg {
      width: 710px;
      height: 710px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      animation: rotates 1s infinite linear;
    }
    @keyframes rotates {
      0% {
        transform: translate(-50%, -50%) rotateZ(0deg);
      }
      100% {
        transform: translate(-50%, -50%) rotateZ(360deg);
        // transform-origin: 50% 50%;
      }
    }
    .close {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      margin-top: 460px;
      width: 60px;
      height: 60px;
      cursor: pointer;
    }
  }
}
</style>